module.exports = __webpack_public_path__ + "img/chrome-1.5fd3c6a4.png";